import axiosInstance from '../api/axiosInstance';

const getMedineerPageCounts = async () => {
    const response = await axiosInstance.get(
        '/api/Courses/getMedineerLandingPageCounts'
    );
    return response.data;
};

export default getMedineerPageCounts;
